export default "__VITE_ASSET__32447569__"